function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import './cursor.css';
export var Cursor = /*#__PURE__*/function () {
  function Cursor() {
    this.states = new Set();
  }
  var _proto = Cursor.prototype;
  _proto.setDragging = function setDragging(flag) {
    if (flag) {
      this.addState('dragging');
    } else {
      this.removeState('dragging');
    }
  };
  _proto.setXResizing = function setXResizing(flag) {
    if (flag) {
      this.addState('x-resizing');
    } else {
      this.removeState('x-resizing');
    }
  };
  _proto.setYResizing = function setYResizing(flag) {
    if (flag) {
      this.addState('y-resizing');
    } else {
      this.removeState('y-resizing');
    }
  };
  _proto.setCopy = function setCopy(flag) {
    if (flag) {
      this.addState('copy');
    } else {
      this.removeState('copy');
    }
  };
  _proto.isCopy = function isCopy() {
    return this.states.has('copy');
  };
  _proto.release = function release() {
    for (var _iterator = _createForOfIteratorHelperLoose(this.states), _step; !(_step = _iterator()).done;) {
      var state = _step.value;
      this.removeState(state);
    }
  };
  _proto.addState = function addState(state) {
    if (!this.states.has(state)) {
      this.states.add(state);
      document.documentElement.classList.add("lc-cursor-" + state);
    }
  };
  _proto.removeState = function removeState(state) {
    if (this.states.has(state)) {
      this.states["delete"](state);
      document.documentElement.classList.remove("lc-cursor-" + state);
    }
  };
  return Cursor;
}();
export var cursor = new Cursor();